import { atom } from 'recoil'

export const call = atom({
  key: 'call',
  default: {
    muteCamera: false,
    muteMicrophone: false,
    endCall: false,
  },
})
